<template>
  <div
    class="text-gray-400 text-lg font-bold">
    <p
      v-if="!!timeoutMessage"
      class="text-red-500">
      {{ timeoutMessage }}
    </p>
    <p v-else>
      {{ `${zeroPadding(hours)} : ${zeroPadding(minutes)} : ${zeroPadding(seconds)}` }}
    </p>
  </div>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import {
  computed, ref, reactive, onUnmounted,
} from 'vue'
import zeroPadding from '../../../actions/format/zero-padding'

const props = defineProps({
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: Number,
    default: 0,
  },
  startAnswerTime: {
    type: String,
    default: '',
  },
  setLimitSeconds: {
    type: Number,
    required: true,
  },
})
const now = moment().format('YYYY-MM-DD HH:mm:ss')

// 試験の終了時間
const finishExaminationTime = computed(() => {
  const conversionMinutes = props.setLimitSeconds / 60
  return moment(props.startAnswerTime).add(conversionMinutes, 'm').format()
})

const hours = ref('')
const minutes = ref('')
const seconds = ref('')
const timeoutMessage = ref('')

const form = reactive(Inertia.form({
  answerList: null,
  examination: props.examination,
  type: props.type,
}))

// 試験の終了時間から現在時間の差分
const diffVariousTime = () => {
  const diffSeconds = moment(finishExaminationTime.value).diff(moment(now.value))
  if (diffSeconds >= 0) {
    const durationObject = moment.duration(diffSeconds)
    hours.value = durationObject.hours()
    minutes.value = durationObject.minutes()
    seconds.value = durationObject.seconds()
  } else {
    hours.value = 0
    minutes.value = 0
    seconds.value = 0
    timeoutMessage.value = 'タイムアウト'

    const json = localStorage.getItem('answers')
    const array = json != null ? JSON.parse(json) : []
    form.answerList = array
    form.post('/finish', {
      onSuccess: () => {
        localStorage.clear()
      },
    })
  }
}
diffVariousTime()

const timerId = ref('')
const countDown = () => {
  timerId.value = setInterval(diffVariousTime, 1000)
}
countDown()

onUnmounted(() => {
  clearInterval(timerId.value)
})
</script>
